"use client";

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";
import type { HomeFeaturedPeptides } from "./home-featured-peptides";

const HomeFeaturedPeptidesGrid = dynamic(
	() => import("./home-featured-peptides").then((mod) => mod.HomeFeaturedPeptides),
	{
		ssr: false,
		loading: () => <div className="relative hidden min-h-[52rem] lg:block" aria-hidden />,
	},
);

type Props = ComponentProps<typeof HomeFeaturedPeptides>;

/** The assortment under the hero is below the first view. Reserve its box, then load the cards. */
export function HomeFeaturedDeferred({ products }: Props) {
	if (!products.length) return null;
	return <HomeFeaturedPeptidesGrid products={products} />;
}
